import o from "./isSymbol.js";
var f = 1 / 0;
function n(r) {
  if (typeof r == "string" || o(r))
    return r;
  var t = r + "";
  return t == "0" && 1 / r == -f ? "-0" : t;
}
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_toKey.js
// module id = 300
// module chunks = 41